import { Image } from './image';

export enum ArticleClass {
  GALLERY = 'Gallery',
  VIDEO = 'Video',
  ARTICLE = 'Article',
}

export interface Article {
  groupId: string;

  imprId?: string;

  articleClass: ArticleClass;

  canonicalUri: string;

  author: ArticleAuthor;

  title: string;

  shortContent: string;

  imageList: Image[];

  largeImage: Image;

  articleLikes: number;
}

export interface ArticleAuthor {
  userId: string;

  nickName: string;

  description: string;

  avatar: string;

  publishCount: number;

  authInfo: any;
}
